module.exports = __webpack_public_path__ + "static/img/ku-ipp.db4f76a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/ku-ipp.jpg
// module id = Jo+U
// module chunks = 0